import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, NgModule } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Documento, DocumentiEqualtecResult, DocumentiEqualtecResultObject, AttachmentDto, Evidenza } from '../../models/data.model';
import { CommonService } from '../../services/common.service';
import { EqualtecService } from '../../services/equaltec.service';
import { MimetypeService } from '../../services/mimetype.service';

@Component({
  selector: 'app-equaltec-link',
  templateUrl: './EqualtecLink.component.html'
})

export class EqualtecLink implements OnInit {


  constructor(public translate: TranslateService,
    public equaltecService: EqualtecService,
    private documentiEqualtecResultService: CommonService<DocumentiEqualtecResult>,
    private evidenzaService: CommonService<Evidenza>,
    private documentService: CommonService<Documento>,
    private creaEvidenzaService: CommonService<string>,
    private http: HttpClient,
    private fileServer: CommonService<AttachmentDto>,
    private mimeTypeService: MimetypeService
  ) { }

  isTabellaLinkConUnElemento: boolean = false
  paginaDescrizioneDocumentoCorrente: string = ""
  docApertiLink = 0
  isExpandedLink: boolean = false
  isTabellaLinkRevisionPending: boolean = false
  documentiCollegati: Documento[] = [];
  labelNoRecord: boolean = false;
  managedDocument: Documento;


  ngOnInit(): void {

    this.managedDocument = this.equaltecService.selectedDocument
    this.apriPaginaDocCollegati(this.managedDocument.idDocumento, this.managedDocument.descrizioneDocumento)
  }

  apriPaginaDocCollegati = (idDocumento, descrizioneDocumento) => {
    this.paginaDescrizioneDocumentoCorrente = descrizioneDocumento;
    this.docApertiLink = 0;
    this.labelNoRecord = false;
    this.isExpandedLink = false;
    this.isTabellaLinkRevisionPending = false;
    const url = 'api/rest/GetDocumentiCollegatiByIdDocumento';
    const input = { iddocumento: idDocumento };
    this.documentService.postData(url, input, false).subscribe(result => {
      if (result) {
        console.log('this is documents : ', result);

        this.documentiCollegati = result as Documento[];
        this.documentiCollegati.forEach(d => {
          d.metadatiDtoViewList = d.metadatiDtoShortList;
          d.apriDettaglio = "Open detail";
          if (d.isNewRevisionPending) {
            this.isTabellaLinkRevisionPending = true;
          }
        });
        this.labelNoRecord = true;
      }
    })
  }

  getArcadocAttach(item: AttachmentDto, iddocumento: number, download: boolean) {
    const url = 'api/rest/GetAttachment';
    const params = {
      params: {
        idAllegato: item.idAllegato,
        idDocument: iddocumento,
        fileName: item.nomeFile,
        download: download
      }
    };
    this.fileServer.getData(url, params, false).toPromise()
      .then(res => {
        const attachment: AttachmentDto = res as AttachmentDto;
        const fileName = attachment.nomeFile;
        const ext = fileName.split('.').pop() || '';
        const downloadLink = document.createElement("a");
        this.dataURIToBlob(attachment.data, this.mimeTypeService.getMimeType(ext))
          .then(b => {
            const blob: Blob = b as Blob;
            const url = URL.createObjectURL(blob);
            if (download) {
              downloadLink.href = url;
              downloadLink.download = fileName;
              downloadLink.click();
            } else {
              window.open(url, '_blank')
            }
          })
      });
  }

  dataURIToBlob = (dataURI: any, mimeString: string) => {
    return new Promise(resolve => {
      const binStr = atob(dataURI),
        len = binStr.length,
        arr = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      const result = new Blob([arr], {
        type: mimeString
      });
      resolve(result)
    })
  }

  documentDetail = (apridettaglio, descr, codice, tipodocumento, revisione, identificazioneDocumento, processOGuideline, doc?: Documento) => {
    if (apridettaglio == "Open detail") {
      this.openDocumentDetail(descr, codice, tipodocumento, revisione, identificazioneDocumento, processOGuideline);
    } else {
      this.closeDocumentDetail(descr, codice, tipodocumento, revisione, identificazioneDocumento, processOGuideline);
    }
  }

  openDocumentDetail = (descr, codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella) => {
    switch (tipoDiTabella) {
      case "link": {
        this.docApertiLink++;
        let documentiAperti = 0;
        this.isExpandedLink = true;
        this.documentiCollegati.forEach(doc => {
          if (doc.isNewRevisionPending) {
            this.isTabellaLinkRevisionPending = true;
          }
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.metadatiDtoViewList = doc.metadatiDtoList;
            if (this.documentiCollegati.length > 1) {
              const y = { key: '', value: '' }
              doc.metadatiDtoViewList.splice(3, 0, y);
              doc.metadatiDtoViewList.splice(4, 0, y);
              if (this.isTabellaLinkRevisionPending) {
                doc.metadatiDtoViewList.splice(5, 0, y);
              }
            } else {
              this.isTabellaLinkConUnElemento = true;
            }
            doc.apriDettaglio = "Close detail";
          }
        })
        this.documentiCollegati.forEach(doc => {
          if (doc.apriDettaglio == "Close detail")
            documentiAperti++;
        })
        if (documentiAperti == this.documentiCollegati.length && this.documentiCollegati.length > 1) {
          this.isTabellaLinkConUnElemento = true;
          this.documentiCollegati.forEach(doc => {
            const spl = this.isTabellaLinkRevisionPending ? 3 : 2;
            doc.metadatiDtoViewList.splice(3, spl);
          })
        }
        break;
      }


      default: {
        break;
      }
    }
  }

  closeDocumentDetail = (descr, codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella) => {
    switch (tipoDiTabella) {
      case "link": {
        let documentiApertiFull = 0;
        this.documentiCollegati.forEach(doc => {
          if (doc.apriDettaglio == "Close detail")
            documentiApertiFull++;
        })
        if (documentiApertiFull == this.documentiCollegati.length && this.documentiCollegati.length > 1) {
          this.isTabellaLinkConUnElemento = false;
          this.documentiCollegati.forEach(doc => {
            const y = { key: '', value: '' }
            doc.metadatiDtoViewList.splice(3, 0, y);
            doc.metadatiDtoViewList.splice(4, 0, y);
            if (this.isTabellaLinkRevisionPending) {
              doc.metadatiDtoViewList.splice(5, 0, y);
            }
          })
        }
        this.docApertiLink--;
        this.documentiCollegati.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            if (this.documentiCollegati.length > 1) {
              const spl = this.isTabellaLinkRevisionPending ? 3 : 2;
              doc.metadatiDtoViewList.splice(3, spl);
            }
            doc.metadatiDtoViewList = doc.metadatiDtoShortList;
            doc.apriDettaglio = "Open detail";
          }
        })
        if (this.docApertiLink == 0) {
          this.isExpandedLink = false;
        }
        break;
      }

      default: {
        break;
      }
    }
  }

}




